import { Link } from 'react-router-dom';

interface CategoryCardProps {
  name: string;
  image: string;
}

export function CategoryCard({ name, image }: CategoryCardProps) {
  return (
    <Link 
      to={`/products?category=${name}`}
      className="group relative bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow"
    >
      <div className="aspect-w-1 aspect-h-1 w-full overflow-hidden">
        <img 
          src={image} 
          alt={name}
          className="w-full h-full object-cover object-center group-hover:opacity-90 transition-opacity"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute inset-0 flex items-end justify-center p-4">
          <p className="text-lg font-medium text-white">{name}</p>
        </div>
      </div>
    </Link>
  );
}